export const supportedLocales = [
  'en',
  'pl',
  'de',
  'uk',
  'fr',
  'it',
  'pt',
  'es',
  'tr',
  'zh',
  'sk',
  'el',
  'ru',
  'bg',
]
